import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { useSelector } from 'react-redux';

// Section компонентууд
import Hero from 'components/home/Hero';
import EpcSection from 'components/home/EpcSection';
import InfrastructureSection from 'components/home/InfrastructureSection';
import ActivitySummarySection from 'components/home/ActivitySummarySection';
import QuotesSection from 'components/home/QuotesSection';
import LatestNewsSection from 'components/home/LatestNewsSection';
import TestimonialsSection from 'components/home/TestimonialsSection';
import PartnersSection from 'components/home/PartnersSection';
import CtaSection from 'components/home/CtaSection';
import TimelineSection from 'components/home/TimelineSection';

// Actions
import { getActiveCovers } from 'context/actions/cover';
import { getEpcPackages } from 'context/actions/epcPackages';
import { getInfrastructure } from 'context/actions/infrastructure';
import { getActivitySummaries } from 'context/actions/activitySummary';
import { getQuotes } from 'context/actions/quotes';
import { getTimelineHighlights } from 'context/actions/timeline';
import { getNewsClient } from 'context/actions/news';
import { getTestimonials } from 'context/actions/testimonials';
import { getPartners } from 'context/actions/partners';

export default function Home() {
    const lang = useSelector((s) => s.system.lang || 'mn');
    const companyInfo = useSelector((s) => s.system.companyInfo || {});

    const [covers, setCovers] = useState([]);
    const [epc, setEpc] = useState([]);
    const [infra, setInfra] = useState([]);
    const [activitySummaries, setActivitySummaries] = useState([]);
    const [quotesList, setQuotesList] = useState([]);
    const [timeline, setTimeline] = useState([]);
    const [news, setNews] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [partners, setPartners] = useState([]);

    useEffect(() => {
        // Бүх section-д хэрэгтэй data-г параллел татах
        (async () => {
            try {
                const [
                    coversRes,
                    epcRes,
                    infraRes,
                    activityRes,
                    quotesRes,
                    timelineRes,
                    newsRes,
                    testRes,
                    partnersRes,
                ] = await Promise.all([
                    getActiveCovers(5),
                    getEpcPackages(),
                    getInfrastructure(),
                    getActivitySummaries(),
                    getQuotes(),
                    getTimelineHighlights(),
                    getNewsClient(6, 'news'),
                    getTestimonials(),
                    getPartners(),
                ]);

                if (coversRes?.data) setCovers(coversRes.data);
                if (epcRes?.data) setEpc(epcRes.data);
                if (infraRes?.data) setInfra(infraRes.data);
                if (activityRes?.data) setActivitySummaries(activityRes.data);
                if (quotesRes?.data) setQuotesList(quotesRes.data);
                if (timelineRes?.data) setTimeline(timelineRes.data);
                if (newsRes?.data) setNews(newsRes.data);
                if (testRes?.data) setTestimonials(testRes.data);
                if (partnersRes?.data) setPartners(partnersRes.data);
            } catch (e) {
                console.error('Home data fetch error:', e);
            }
        })();
    }, []);

    // ─── SEO meta ───
    const siteUrl =
        process.env.NEXT_PUBLIC_SITE_URL || 'https://mongolrefinery.mn';
    const title =
        lang === 'en'
            ? 'Mongol Refinery — Building Mongolia\'s Energy Future'
            : 'Монгол Газрын Тос Боловсруулах Үйлдвэр ТӨХХК';
    const description =
        lang === 'en'
            ? "Mongol Refinery State Owned LLC is implementing Mongolia's first oil refinery project, funded by the Government of India."
            : 'Монгол Газрын Тос Боловсруулах Үйлдвэр ТӨХХК нь БНЭУ-ын Засгийн газрын зээлийн хөрөнгөөр Монгол улсын анхны газрын тос боловсруулах үйлдвэрийн төслийг хэрэгжүүлж байна.';

    return (
        <>
            <Head>
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:url" content={siteUrl} />
                <link rel="canonical" href={siteUrl} />
            </Head>

            {/* ═══ Hero ═══ */}
            <Hero covers={covers} />

            {/* ═══ Latest news ═══ */}
            <LatestNewsSection news={news} />

            {/* ═══ EPC packages ═══ */}
            <EpcSection epcPackages={epc} />

            {/* ═══ Infrastructure projects ═══ */}
            <InfrastructureSection items={infra} />

            {/* ═══ Төслийн үе шатууд (timeline) — Үйл ажиллагааны товчооны байрлалд ═══ */}
            <TimelineSection items={timeline} />

            {/* ═══ Ишлэл ═══ */}
            <QuotesSection quotes={quotesList} />

            {/* ═══ Testimonials slider ═══ */}
            <TestimonialsSection testimonials={testimonials} />

            {/* ═══ Partners ═══ */}
            <PartnersSection partners={partners} />

            {/* ═══ CTA ═══ */}
            <CtaSection />
        </>
    );
}